/**
 * WhatsApp Specific Styling Constants
 */

// Background Colors
export const WHATSAPP_BG_COLOR = '#F5F0E6';
export const WHATSAPP_LIGHT_BG_COLOR = '#F5F0E6';

// Wallpaper Patterns
export const WHATSAPP_BG_IMAGE_URL = '/whatsapp-bg.png';

// Brand Colors
export const WHATSAPP_BRAND_COLOR = '#1b8755';
export const WHATSAPP_BUTTON_BG_COLOR = '#25D366';
export const WHATSAPP_BUTTON_HOVER_BG_COLOR = '#20ba5a';

// Message Bubble Colors
export const WHATSAPP_MESSAGE_USER_BG = '#dcf8c6';
export const WHATSAPP_MESSAGE_BOT_BG = '#ffffff';

// Text Colors
export const WHATSAPP_TEXT_COLOR = '#111b21';
export const WHATSAPP_SECONDARY_TEXT_COLOR = '#667781';

// Status Colors
export const WHATSAPP_STATUS_PENDING_COLOR = '#667781';
export const WHATSAPP_STATUS_SENT_COLOR = '#667781';
export const WHATSAPP_STATUS_DELIVERED_COLOR = '#667781';
export const WHATSAPP_STATUS_READ_COLOR = '#34B7F1';
export const WHATSAPP_STATUS_FAILED_COLOR = '#EF5350';
